// src/components/dashboard/table-planner/GuestListPanel.jsx
import React from "react";
import GuestCard from "./GuestCard";

export default function GuestListPanel({
  guests,
  searchTerm,
  onSearchChange,
  onDragStart,
  onDragEnd,
  invitedByFilter,
  onFilterChange,
  selectedGuest, // New prop
  onGuestSelect, // New prop
}) {
  const filterOptions = ["all", "bride", "groom"];

  return (
    <div className="lg:col-span-1 bg-white/70 p-4 rounded-xl shadow-sm backdrop-blur-sm self-start sticky top-4">
      <h2 className="text-xl font-bold text-[#931b1c] mb-4">
        Unseated Guests ({guests.length})
      </h2>
      <input
        type="text"
        value={searchTerm}
        onChange={onSearchChange}
        placeholder="Search by guest name..."
        className="w-full mb-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#931b1c]"
      />
      <div className="flex items-center gap-2 my-4">
        <span className="text-sm font-semibold text-gray-600">Filter by:</span>
        {filterOptions.map((filter) => (
          <button
            key={filter}
            onClick={() => onFilterChange(filter)}
            className={`px-3 py-1 text-sm font-semibold rounded-full capitalize transition-colors ${
              invitedByFilter === filter
                ? "bg-[#931b1c] text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            {filter}
          </button>
        ))}
      </div>
      <div className="space-y-2 max-h-[calc(100vh-18rem)] overflow-y-auto pr-2">
        {guests.map((guest) => (
          <GuestCard
            key={guest.id}
            guest={guest}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            isSelected={selectedGuest?.id === guest.id} // Check if this card is selected
            onSelect={onGuestSelect} // Pass handler down
          />
        ))}
      </div>
    </div>
  );
}
